import {
  FaLinkedin,
  FaFacebookSquare,
  FaInstagramSquare,
  FaYoutube,
} from "react-icons/fa";
import "../styles/footer.scss";
import sendWaMessage from "../scripts/sendWaMessage";

// --- Sub-componentes para hacer el código más limpio ---

// 1. Componente para renderizar UNA columna del footer
function FooterColumn({ title, links, onLinkClick }) {
  return (
    <div className="column">
      <h3>{title}</h3>
      {links.map((link) => (
        <a
          key={link.label}
          href="#main-tab"
          onClick={(e) => onLinkClick(e, link.tabId)}
        >
          {link.label}
        </a>
      ))}
    </div>
  );
}

// 2. Componente para renderizar los iconos de redes sociales
function SocialLinks({ links }) {
  return (
    <div className="social-icons">
      {links.map(({ href, Icon, name }) => (
        <a
          key={name}
          href={href}
          target="_blank"
          rel="noreferrer"
          aria-label={name}
        >
          <Icon />
        </a>
      ))}
    </div>
  );
}

function Footer({ setTab, data, textContent }) {
  // Lógica centralizada para los clics en enlaces internos
  const handleLinkClick = (event, tabId) => {
    event.preventDefault();
    setTab(tabId);
    window.scrollTo(0, 0);
  };

  // 4. Creamos un array para los datos de redes sociales.
  const socialLinksData = [
    { href: data.socialMedia.linkedin, Icon: FaLinkedin, name: "LinkedIn" },
    {
      href: data.socialMedia.facebook,
      Icon: FaFacebookSquare,
      name: "Facebook",
    },
    {
      href: data.socialMedia.instagram,
      Icon: FaInstagramSquare,
      name: "Instagram",
    },
    { href: data.socialMedia.youtube, Icon: FaYoutube, name: "YouTube" },
  ];

  // 5. Creamos un array para los enlaces inferiores.
  const bottomLinksData = [
    { href: data.externalLinks.termsConditions, label: "Terms & Conditions" },
    { href: data.externalLinks.privacyPolicy, label: "Privacy Policy" },
    { href: data.externalLinks.referralURL, label: "Referral program" },
    { href: data.externalLinks.partnerProgram, label: "Partner Program" },
  ];

  return (
    <footer className="main-footer">
      <div className="footer-top">
        <section className="email-social-links">
          <h3>Elite Special Solutions</h3>
          <form className="email-form" onSubmit={sendWaMessage}>
            <input
              type="email" // Usamos type="email" para validación automática
              name="email"
              autoComplete="email"
              placeholder="Your email"
              required // Buena práctica añadir validación básica
            />
            <button type="submit">Send</button>
          </form>
          <SocialLinks links={socialLinksData} />
        </section>

        <section className="info">
          {/* 6. Mapeamos los datos para generar las columnas dinámicamente */}
          {textContent.footer.map((column) => (
            <FooterColumn
              key={column.title}
              title={column.title}
              links={column.links}
              onLinkClick={handleLinkClick}
            />
          ))}
        </section>
      </div>

      <div className="footer-bottom">
        {bottomLinksData.map((link) => (
          <a
            key={link.label}
            href={link.href}
            target="_blank"
            rel="noopener noreferrer"
          >
            {link.label}
          </a>
        ))}
        <p>
          {" "}
          {/* Usar <p> para el texto de copyright es semánticamente mejor */}©{" "}
          {new Date().getFullYear()} Web Developed by{" "}
          <a
            href="http://bsitescomp.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            <b>B‑Sites</b>
          </a>
        </p>
        <p>
          {" "}
          {/* Usar <p> para el texto de copyright es semánticamente mejor */}
          <a
            href="https://www.freepik.es"
            target="_blank"
            rel="noopener noreferrer"
          >
            Images by Freepik.es
          </a>
        </p>
      </div>
    </footer>
  );
}

export default Footer;
